import OpenedImagePlantas from "./OpenedImagePlantas";

export default OpenedImagePlantas;
